var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AnimatedNumbershapeSprite",class:{ reversed: _vm.reversed, inverted: _vm.inverted, playing: _vm.play, paused: _vm.paused },attrs:{"data-numbershape-number":_vm.number}},[_c('div',{staticClass:"number"})])}
var staticRenderFns = []

export { render, staticRenderFns }